import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { RatingNotationComponent } from "./rating-notation.component";
import { LabelModule } from "../../service/label/label.module";
import { RatingShapeModule } from "../rating-shape/rating-shape.module";
import { LanguageService } from "libraries/service/language/language.service";

@NgModule({
    declarations: [RatingNotationComponent],
    exports: [
        RatingNotationComponent,
        LabelModule,
    ],
    imports: [
        CommonModule,
        RatingShapeModule,
    ],
    providers: [
        LanguageService,
    ]
})
export class RatingNotationModule {
}
